module.exports = {
    getLoginInfo() {
        let isLogin = false;
        let isMembership = false;
        Odigeo.requireWidget('login-header', 'login', function(login) {
            isLogin = login.model.logged;
            isMembership = login.model.isMembership;
        });
        return {
            isLogin,
            isMembership,
        };
    },
    getTrackingSuffix() {
        const {isLogin, isMembership} = this.getLoginInfo();
        const isPrimeRememberMeCookie = this.isPrimeFromCookie('sso_remember_me');
        const isPrimeRememberPrimeCookie = this.isPrimeFromCookie('remember_prime_booking');
        let trackingSuffix;
        if (isLogin && isMembership) {
            trackingSuffix = 'login_prime';
        } else if (isPrimeRememberMeCookie) {
            trackingSuffix = 'rm';
        } else if (isPrimeRememberPrimeCookie) {
            trackingSuffix = 'rp';
        } else {
            trackingSuffix = 'other';
        }
        return trackingSuffix;
    },

    isPrimeFromCookie(cookieName) {
        let cookie = decodeURIComponent(Odigeo.Utils.readCookie(cookieName)) || '';
        let splitCookie = cookie.split(';');
        return 2 <= splitCookie.length && 'true' === splitCookie[2];
    },
};
